import { Typography } from '@mui/material';

import { type ThemaFromThemaRouter } from '../../dtos';
import { content } from './Pendant.content';
import { SelectableChipGroup } from './SelectableChipGroup';

type OnlinePraesenzFilterProps = {
  readonly thema: ThemaFromThemaRouter;
  readonly allOptions: React.ComponentProps<typeof SelectableChipGroup>['options'];
  readonly selectedOptions: React.ComponentProps<typeof SelectableChipGroup>['selectedOptions'];
  readonly toggleOption: React.ComponentProps<typeof SelectableChipGroup>['onSelectionChange'];
};

export const OnlinePraesenzFilter = ({
  thema,
  allOptions,
  selectedOptions,
  toggleOption,
}: OnlinePraesenzFilterProps) => {
  const pendantCount = thema.pendantThemen.length;

  if (pendantCount === 0) {
    return null;
  }

  if (pendantCount > 1) {
    return (
      <Typography variant="labelLight" color="textTertiary">
        {content.mehrerePendants}
      </Typography>
    );
  }

  return (
    <SelectableChipGroup options={allOptions} selectedOptions={selectedOptions} onSelectionChange={toggleOption} />
  );
};
